export default (store) => () => {
  const experiments = store.getters['goodall/getExperiments'];
  const experimentNames = Object.keys(experiments);
  const enabledExperimentNames = experimentNames
    .filter((experiment) => experiments[experiment] !== undefined);
  if (enabledExperimentNames.length < 1) {
    // empty object in meta tags array will be ignored
    return {};
  }
  const metaTagGoodall = {};
  metaTagGoodall.name = 'goodall';
  metaTagGoodall['data-track-id'] = 'goodall';
  enabledExperimentNames.forEach((experiment) => {
    metaTagGoodall[`data-exp-${experiment}`] = experiments[experiment];
  });
  return metaTagGoodall;
};
